<template>
    <div id="Foot">
        <div class="footer">
            <div class="body">
                <div class="logo">

                </div>
                <div class="link">
                    <ul class="about">
                        <li class="title"><a href="aboutWe.html">关于我们</a></li>
                        <li class="child"><a href="aboutWe.html#companyJj" target="_blank">公司简介</a></li>
                        <li class="child"><a href="notice.html" target="_blank">组团公告</a></li>
                        <li class="child"><a href="aboutWe.html#/hzLx" target="_blank">联系我们</a></li>
                    </ul>
                    <ul class="about">
                        <li class="title"><a href="javascript:;">产品服务</a></li>
                        <li class="child"><a href="mg.html" target="_blank">美逛APP</a></li>
                        <li class="child"><a href="cms.html" target="_blank">CMS商城</a></li>
                        <li class="child"><a href="boutique.html" target="_blank">精品单页</a></li>
                        <li class="child">API接口
                        </li>
                    </ul>
                    <ul class="about">
                        <li class="title"><a href="http://help.zutuan.cn/" target="_blank">帮助中心</a></li>
                        <li class="child"><a href="http://help.zutuan.cn/#/&essayid=2" target="_blank">新手入门</a></li>
                        <li class="child"><a href="http://help.zutuan.cn/#/&essayid=1" target="_blank">常见问题</a></li>
                        <li class="child"><a href="http://help.zutuan.cn/#/&essayid=4" target="_blank">APP教程</a></li>
                    </ul>
                    <ul class="about">
                        <li class="title"><a href="javascript:;">客服中心</a></li>
                        <!-- <li class="child"><span class="qq" id="mgKfQy_qq3" style="cursor: pointer">QQ客服</span>
                        </li> -->
                        <li class="child"><a href="javascript:;">微信客服</a></li>
                        <li class="child">
                            <div class="img"></div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="bottom">
                <!-- ©copyright 2010-2019 组团推 www.zutuan.cn.浙ICP备 16028266号-4 杭州四禾电子商务有限公司<span id="cnzz_stat_icon_1276337123" ></span> -->
                ©copyright 2010-2019 组团推 www.zutuan.cn.<a href="https://beian.miit.gov.cn" style="color: #636363">浙ICP备 16028266号-4 </a><span id="cnzz_stat_icon_1276337123" ></span>
            </div>
        </div>

    </div>
</template>
<script>
	import $ from 'jquery';
    export default {
        name: 'Foot',
        data() {
            return {}
        },
        mounted() {
        	//cnzz
			var cnzz_protocol = (("https:" == document.location.protocol) ? "https://" : "http://");
			document.head.appendChild(document.createElement('script')).src = "" + cnzz_protocol + "s5.cnzz.com/z_stat.php?id=1276337123&show=pic1";
        },
        methods:{
			
        }
    }
</script>
<style src="./css/Foot.css" scoped>

</style>